<app-navbar></app-navbar>

<div class="dashboard-full-width">
  <div class="">
    <div class="main-container-dashboard">
      <!-- <app-ministry-sidebar></app-ministry-sidebar> -->

      <div class="dashboard-container-right">
        <div class="main-container">
          <div class="row">
            <div class="card shadow m-3" style="width: 100%">
              <div
                class="
                  card-header
                  heading_n_button_box
                  card-header-cus-new-appoint
                "
              >
                <div class="card-heading">
                  <h4>List of Registered Passengers</h4>
                </div>

                <div class="button-section mt-1"></div>
              </div>

              <div class="card-body">
                <div class="col-lg-12">
                  <div class="col-lg-12">
                    <form
                      [formGroup]="searchForm"
                      (ngSubmit)="onSubmitSearch(searchForm.value)"
                    >
                      <div class="row">
                        <!-- <div class="col-lg-3 mt-320_view">
                          <select
                            class="form-select select-option col-lg-12"
                            name="age_group"
                            formControlName="age_group"
                            id="age_group"
                          >
                            <option selected value="">Age Group</option>
                            <option value="1">Group 1</option>
                            <option value="2">Group 2</option>
                          </select>
                        </div> -->

                        <div class="col-lg-3 col-sm-6 col-md-6 mt-320_view">
                          <select
                            class="form-select select-option col-lg-12"
                            name="gender"
                            formControlName="gender"
                            id="gender"
                          >
                            <option selected value="">Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                          </select>
                        </div>

                        <div class="col-lg-3 col-sm-6 col-md-6 mt-320_view">
                          <select
                            class="form-select select-option col-lg-12"
                            name="nationality"
                            formControlName="nationality"
                            id="nationality"
                          >
                            <option selected value="">Nationality</option>
                            <option
                              *ngFor="let country of shared.countries"
                              value="{{ country.name }}"
                            >
                              {{ country.name }}
                            </option>
                          </select>
                        </div>

                        <div class="col-lg-3 col-sm-6 col-md-6 mt-320_view">
                          <input
                            class="form-control icon-cal font-12"
                            type="text"
                            formControlName="daterangeInput"
                            placeholder="Registration: Date From - Date To"
                            daterangepicker
                            [options]="options"
                            (selected)="selectedDate($event, daterange)"
                            title="Registration: Date From - Date To"
                          />
                        </div>

                        <div class="col-lg-3 col-sm-6 col-md-6 mt-320_view">
                          <div class="mr-4">
                            <button
                              class="
                                btn btn-secondary
                                theme-btn-2
                                dropdown-toggle-no
                              "
                              type="submit"
                              id="dropdownMenuButton"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i class="fas fa-search"></i> Search
                            </button>

                            <button
                              class="
                                btn btn-secondary
                                theme-btn-2
                                dropdown-toggle-no
                                ml-2
                              "
                              type="button"
                              id="dropdownMenuButton"
                              aria-haspopup="true"
                              aria-expanded="false"
                              (click)="clearSearch()"
                            >
                              <i class="fas fa-sync-alt"></i> Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div class="">
                    <div class="mt-3">
                      <div class="col-auto">
                        <div class="row" *ngIf="registeredPassengers">
                          <div class="show-record mt-3 mbm-32">
                            <span>Show</span> &nbsp;
                            <select
                              class="
                                custom-select custom-select-sm
                                form-control form-control-sm
                              "
                              (change)="setItemsPerPage(page.value)"
                              #page
                            >
                              <option [selected]="currentPageLength == 10">
                                10
                              </option>
                              <option [selected]="currentPageLength == 30">
                                30
                              </option>
                              <option [selected]="currentPageLength == 50">
                                50
                              </option>
                              <option [selected]="currentPageLength == 100">
                                100
                              </option>
                              <option [selected]="currentPageLength == 500">
                                500
                              </option>
                              <option [selected]="currentPageLength == 1000">
                                1000
                              </option>
                            </select>
                            &nbsp;
                            <span> entries</span>
                          </div>
                        </div>
                      </div>
                      <div class="table table-responsive">
                        <table
                          *ngIf="registeredPassengers"
                          class=""
                          datatable
                          [dtOptions]="dtOptions"
                          width="100%"
                        >
                          <thead>
                            <tr>
                              <th>S/N</th>
                              <th>Passenger ID</th>
                              <th>Passenger Name</th>
                              <th>Passport Number</th>
                              <th>Phone Number</th>
                              <th>Email</th>
                              <th>Gender</th>
                              <th>Country Of Residence</th>
                              <th>Nationality</th>
                              <th>Date Of Birth</th>
                              <th>Travel History Count</th>
                              <!-- <th >Age</th> -->
                              <th>Registration Date</th>
                              <th>View Details</th>
                            </tr>
                          </thead>
                          <tbody class="dashboard-bg-white">
                            <tr
                              *ngFor="
                                let passenger of registeredPassengers
                                  | paginate: config;
                                index as i
                              "
                            >
                              <th scope="row">
                                {{
                                  config.itemsPerPage *
                                    (config.currentPage - 1) +
                                    i +
                                    1
                                }}
                              </th>
                              <td>{{ passenger.ctms_passenger_id }}</td>
                              <td>
                                {{ passenger.first_name }}
                                {{ passenger.middle_name }}
                                {{ passenger.last_name }}
                              </td>
                              <td>{{ passenger.passport_no }}</td>
                              <td>{{ passenger.phone }}</td>
                              <td>{{ passenger.email }}</td>
                              <td>{{ passenger.gender }}</td>
                              <td>{{ passenger.country_residence }}</td>
                              <td>{{ passenger.nationality }}</td>
                              <td>{{ passenger.dob }}</td>
                              <td>{{ passenger.travel_history_count }}</td>
                              <td>
                                {{ passenger.created_at | date }}
                              </td>
                              <td>
                                <button
                                  title="View Passenger Details"
                                  (click)="
                                    showDetails(passenger, showDetailsModal)
                                  "
                                  class="btn-view"
                                  type="button"
                                >
                                  <i class="fas fa-eye"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div class="table-footer">
                        <div
                          id="page_info"
                          class="mt-3 record-show-text-bottom"
                          *ngIf="registeredPassengers"
                        >
                          Showing
                          {{
                            (config.currentPage - 1) * config.itemsPerPage + 1
                          }}
                          - {{ config.currentPage * config.itemsPerPage }} of
                          {{ config.totalItems }} entries
                        </div>

                        <div
                          class="pagination paging-pull-right"
                          *ngIf="registeredPassengers"
                        >
                          <pagination-controls
                            (pageChange)="pageChange($event)"
                            class="my-pagination mt-2 pagination-server"
                          >
                          </pagination-controls>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #showDetailsModal let-modal>
  <div class="card mb-5">
    <div class="card-header heading_n_button_box">
      <h3>
        {{ passengerSingleResponse.first_name }}
        {{ passengerSingleResponse.middle_name }}
        {{ passengerSingleResponse.last_name }} Details
      </h3>
      <button
        type="button"
        class="close-button"
        (click)="modal.close('Save click')"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="card-body p-4">
      <form
        [formGroup]="addPassengerForm"
        (ngSubmit)="onSubmit(addPassengerForm.value)"
      >
        <!-- <div class="row" *ngIf="passengerSingleResponse.qrcode_filepath">
        <div class="col-md-4">
          <img [src]="passengerSingleResponse.qrcode_filepath" alt="" class="border rounded-0" width="150">
        </div>
      </div> -->

        <!-- <div class="row">
          <div class="col-md-4 mt-3">
            <label class="form-label"
              >Passport Number<sup class="ml-1 font-weight-bolder text-danger"
                >*</sup
              ></label
            >
            <input
              type="text"
              class="form-control"
              formControlName="passportNumber"
              maxlength="9"
              [ngClass]="{ 'is-invalid': submitted &amp;&amp; addPassengerForm.controls.passportNumber.errors }"
              placeholder="Passport Number e.g DP8054345"
              disabled
            />

            <div
              *ngIf="submitted &amp;&amp; addPassengerForm.controls.passportNumber.errors"
              class="form-text text-danger"
            >
              <div
                *ngIf="addPassengerForm.controls.passportNumber.errors.required"
              >
                Passport Number is required
              </div>
              <div
                *ngIf="
                  addPassengerForm.controls.passportNumber.errors.minlength
                "
              >
                Passport Number must be at least 9 characters long
              </div>
              <div
                *ngIf="
                  addPassengerForm.controls.passportNumber.errors.maxlength
                "
              >
                Passport Number must be at most 9 characters long
              </div>
            </div>
          </div>

          <div class="col-md-4 mt-3">
            <label class="form-label"
              >First Name<sup class="ml-1 font-weight-bolder text-danger"
                >*</sup
              ></label
            >

            <input
              type="text"
              class="form-control"
              id="firstName"
              formControlName="firstName"
              placeholder="First Name e.g John"
              [ngClass]="{ 'is-invalid': submitted &amp;&amp; addPassengerForm.controls.firstName.errors }"
              disabled
            />

            <div
              *ngIf="submitted &amp;&amp; addPassengerForm.controls.firstName.errors"
              class="form-text text-danger"
            >
              <div *ngIf="addPassengerForm.controls.firstName.errors.required">
                First Name is required
              </div>
              <div *ngIf="addPassengerForm.controls.firstName.errors.maxlength">
                First Name must be under 45 characters
              </div>
              <div *ngIf="addPassengerForm.controls.firstName.errors.pattern">
                First Name must be only alphabets
              </div>
            </div>
          </div>

          <div class="col-md-4 mt-3">
            <label class="form-label"
              >Middle Name
            
            </label>

            <input
              type="text"
              class="form-control"
              id="middleName"
              formControlName="middleName"
              placeholder="Middle Name e.g Doe"
              [ngClass]="{ 'is-invalid': submitted &amp;&amp; addPassengerForm.controls.middleName.errors }"
              disabled
            />

            <div
              *ngIf="submitted &amp;&amp; addPassengerForm.controls.middleName.errors"
              class="form-text text-danger"
            >
              <div *ngIf="addPassengerForm.controls.middleName.errors.required">
                Middle Name is required
              </div>
              <div
                *ngIf="addPassengerForm.controls.middleName.errors.maxlength"
              >
                Middle Name must be under 45 characters
              </div>
              <div *ngIf="addPassengerForm.controls.middleName.errors.pattern">
                Middle Name must be only alphabets
              </div>
            </div>
          </div>

          <div class="col-md-4 mt-3">
            <label class="form-label"
              >Last Name<sup class="ml-1 font-weight-bolder text-danger"
                >*</sup
              ></label
            >

            <input
              type="text"
              class="form-control"
              id="lastName"
              formControlName="lastName"
              placeholder="last Name e.g Smith"
              [ngClass]="{ 'is-invalid': submitted &amp;&amp; addPassengerForm.controls.lastName.errors }"
              disabled
            />

            <div
              *ngIf="submitted &amp;&amp; addPassengerForm.controls.lastName.errors"
              class="form-text text-danger"
            >
              <div *ngIf="addPassengerForm.controls.lastName.errors.required">
                Last Name is required
              </div>
              <div *ngIf="addPassengerForm.controls.lastName.errors.maxlength">
                Last Name must be under 45 characters
              </div>
              <div *ngIf="addPassengerForm.controls.lastName.errors.pattern">
                Last Name must be only alphabets
              </div>
            </div>
          </div>

          <div class="col-md-4 mt-3">
            <label class="form-label"
              >Gender<sup class="ml-1 font-weight-bolder text-danger"
                >*</sup
              ></label
            >
            <select
              type="text"
              class="form-control"
              formControlName="gender"
              placeholder=""
              [ngClass]="{ 'is-invalid': submitted &amp;&amp; addPassengerForm.controls.gender.errors }"
              disabled
            >
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
            <div
              *ngIf="submitted &amp;&amp; addPassengerForm.controls.gender.errors"
              class="form-text text-danger"
            >
              <div *ngIf="addPassengerForm.controls.gender.errors.required">
                Gender is required
              </div>
            </div>
          </div>

          <div class="col-md-4 mt-3">
            <label class="form-label"
              >Date Of Birth<sup class="ml-1 font-weight-bolder text-danger"
                >*</sup
              ></label
            >
            <input
              type="date"
              class="form-control"
              formControlName="dateOfBirth"
              [ngClass]="{ 'is-invalid': submitted &amp;&amp; addPassengerForm.controls.dateOfBirth.errors }"
              placeholder="Date Of Birth"
              disabled
            />
          
          </div>

          <div class="col-md-4 mt-3">
            <label class="form-label"
              >Residential Address<sup
                class="ml-1 font-weight-bolder text-danger"
                >*</sup
              ></label
            >
            <input
              type="text"
              class="form-control"
              formControlName="residentialAddress"
              [ngClass]="{ 'is-invalid': submitted &amp;&amp; addPassengerForm.controls.residentialAddress.errors }"
              placeholder="Residential Address"
              disabled
            />
           
          </div>

          <div class="col-md-4 mt-3">
            <label class="form-label"
              >Nationality<sup class="ml-1 font-weight-bolder text-danger"
                >*</sup
              ></label
            >
            <select
              type="text"
              class="form-control"
              formControlName="nationality"
              placeholder=""
              [ngClass]="{ 'is-invalid': submitted &amp;&amp; addPassengerForm.controls.nationality.errors }"
              disabled
            >
              <option value="">Select Nationality</option>
              <option value="NG">Nigeria</option>
              <option value="GH">Ghana</option>
            </select>
            <div
              *ngIf="submitted &amp;&amp; addPassengerForm.controls.nationality.errors"
              class="form-text text-danger"
            >
              <div
                *ngIf="addPassengerForm.controls.nationality.errors.required"
              >
                Nationality is required
              </div>
            </div>
          </div>

          <div class="col-md-4 mt-3">
            <label class="form-label"
              >Country Of Residence<sup
                class="ml-1 font-weight-bolder text-danger"
                >*</sup
              ></label
            >
            <select
              type="text"
              class="form-control"
              formControlName="countryOfResidence"
              placeholder=""
              [ngClass]="{ 'is-invalid': submitted &amp;&amp; addPassengerForm.controls.countryOfResidence.errors }"
              disabled
            >
              <option value="">Select Country</option>
              <option value="NG">Nigeria</option>
              <option value="GH">Ghana</option>
            </select>
            <div
              *ngIf="submitted &amp;&amp; addPassengerForm.controls.countryOfResidence.errors"
              class="form-text text-danger"
            >
              <div
                *ngIf="
                  addPassengerForm.controls.countryOfResidence.errors.required
                "
              >
                Country Of Residence is required
              </div>
            </div>
          </div>

          <div class="col-md-4 mt-3">
            <label class="form-label"
              >Email Address<sup class="ml-1 font-weight-bolder text-danger"
                >*</sup
              ></label
            >
            <input
              type="email"
              class="form-control"
              formControlName="emailAddress"
              id="emailAddress"
              [ngClass]="{ 'is-invalid': submitted &amp;&amp; addPassengerForm.controls.emailAddress.errors }"
              placeholder="Email address e.g example@example.com"
              disabled
            />
            <div
              *ngIf="submitted &amp;&amp; addPassengerForm.controls.emailAddress.errors"
              class="form-text text-danger"
            >
              <div
                *ngIf="addPassengerForm.controls.emailAddress.errors.required"
              >
                Email is required
              </div>
              <div
                *ngIf="addPassengerForm.controls.emailAddress.errors.pattern"
              >
                Please enter a valid email
              </div>
              <div
                *ngIf="addPassengerForm.controls.emailAddress.errors.maxlength"
              >
                Email must be under 45 characters
              </div>
            </div>
          </div>

          <div class="col-md-4 mt-3">
            <label class="form-label"
              >Phone Number<sup class="ml-1 font-weight-bolder text-danger"
                >*</sup
              ></label
            >
            <input
              type="text"
              class="form-control"
              formControlName="phoneNumber"
              maxlength="11"
              [ngClass]="{ 'is-invalid': submitted &amp;&amp; addPassengerForm.controls.phoneNumber.errors }"
              placeholder="Phone Number e.g 08054345678"
              disabled
            />

            <div
              *ngIf="submitted &amp;&amp; addPassengerForm.controls.phoneNumber.errors"
              class="form-text text-danger"
            >
              <div
                *ngIf="addPassengerForm.controls.phoneNumber.errors.required"
              >
                Phone Number is required
              </div>
              <div
                *ngIf="addPassengerForm.controls.phoneNumber.errors.minlength"
              >
                Phone Number must be at least 11 digit long
              </div>
              <div
                *ngIf="addPassengerForm.controls.phoneNumber.errors.maxlength"
              >
                Phone Number must be at most 11 digit long
              </div>
              <div *ngIf="addPassengerForm.controls.phoneNumber.errors.pattern">
                Phone Number must be numbers only and start with 0
              </div>
            </div>
          </div>

          <div class="col-md-4 mt-3">
            <label class="form-label"
              >Occupation<sup class="ml-1 font-weight-bolder text-danger"
                >*</sup
              ></label
            >
            <input
              type="text"
              class="form-control"
              formControlName="occupation"
              [ngClass]="{ 'is-invalid': submitted &amp;&amp; addPassengerForm.controls.occupation.errors }"
              placeholder="Residential Address"
              disabled
            />
           
          </div>

        
        </div> -->

        <!-- <div class="row mt-4">
          <span
            ><strong>Passenger ID: </strong
            ><u>{{ passengerSingleResponse.ctms_passenger_id }}</u></span
          >
        </div> -->

        <div class="row mt-3">
          <div class="col-md-5">
            <p class="text-dark">
              <span>
                <span class="font-weight-bold">PASSENGER ID: </span>
                {{ passengerSingleResponse.ctms_passenger_id }}
              </span>
            </p>
            <p class="text-dark">
              <span>
                <span class="font-weight-bold">PASSENGER NAME: </span>
                {{ passengerSingleResponse.first_name }}
                {{ passengerSingleResponse.middle_name }}
                {{ passengerSingleResponse.last_name }}
              </span>
            </p>
            <p class="text-dark">
              <span>
                <span class="font-weight-bold">GENDER: </span>
                {{ passengerSingleResponse.gender }}
              </span>
            </p>
            <p class="text-dark">
              <span
                ><span class="font-weight-bold">PASSPORT NO.: </span>
                {{ passengerSingleResponse.passport_no }}</span
              >
            </p>
            <p class="text-dark">
              <span
                ><span class="font-weight-bold">EMAIL: </span>
                {{ passengerSingleResponse.email }}</span
              >
            </p>
            <p class="text-dark">
              <span
                ><span class="font-weight-bold">PHONE: </span>
                {{ passengerSingleResponse.phone }}</span
              >
            </p>

            <p class="text-dark">
              <span
                ><span class="font-weight-bold">DATE OF BIRTH: </span>
                {{ passengerSingleResponse.dob }}
              </span>
            </p>
            <p class="text-dark">
              <span
                ><span class="font-weight-bold">REGISTERATION DATE: </span>
                {{ passengerSingleResponse.created_at | date: "medium" }}</span
              >
            </p>
            <!-- <p class="text-dark">
            <span
              ><span class="font-weight-bold">LAST LOGIN: </span>
              {{ passengerSingleResponse.last_login | date: "medium" }}</span
            >
          </p> -->
          </div>

          <div class="col-md-5">
            <p class="text-dark">
              <span
                ><span class="font-weight-bold">COUNTRY OF RESIDENCE: </span>
                {{ passengerSingleResponse.country_residence }}</span
              >
            </p>
            <p class="text-dark">
              <span
                ><span class="font-weight-bold">RESIDENTIAL ADDRESS: </span>
                {{ passengerSingleResponse.address_residential }}
              </span>
            </p>
            <p class="text-dark">
              <span
                ><span class="font-weight-bold">NATIONALITY: </span>
                {{ passengerSingleResponse.nationality }}</span
              >
            </p>
            <p class="text-dark">
              <span
                ><span class="font-weight-bold">OCCUPATION: </span>
                {{ passengerSingleResponse.occupation }}
              </span>
            </p>
            <p class="text-dark">
              <span>
                <span class="font-weight-bold">TRAVEL HISTORY COUNT: </span>
                {{ passengerSingleResponse.travel_info?.length }}
              </span>
            </p>

            <p class="text-dark">
              <span>
                <span class="font-weight-bold">AGE: </span>
                {{ ageFromDateOfBirthday(passengerSingleResponse.dob) }}
              </span>
            </p>
            <!-- <p class="text-dark">
              <span><span class="font-weight-bold">QR CODE STATUS: </span>
                {{passengerSingleResponse.qrcode_status ? 'TRUE' : 'FALSE'}}
              </span>
            </p> -->
          </div>
        </div>

        <!-- Start Travel History Table - Inbound  -->
        <div
          class="row"
          *ngIf="
            passengerSingleResponse.travel_info_inbound &&
            passengerSingleResponse.travel_info_inbound.length
          "
        >
          <hr />
          <div class="col-md-12">
            <div class="">
              <div class="mt-5">
                <div class="col-auto">
                  <div class="row">
                    <div class="col-md-12">
                      <!-- <h3>Inbound Travel Record</h3> -->
                    </div>
                  </div>
                </div>

                <div class="table">
                  <table
                    class="table-responsive"
                    datatable
                    [dtOptions]="dtOptions"
                    width="100%"
                  >
                    <thead class="">
                      <tr>
                        <!-- <th >Departing Country</th>
                        <th >Departure Date</th>
                        <th >Return Date</th> -->

                        <th>Arriving Country</th>
                        <th>Arriving State</th>
                        <th>Arrival Date</th>

                        <th>Transit Country</th>
                        <th>Airline</th>
                        <th>Test Status</th>
                        <th>Country Of Residence</th>
                        <th>Residential Address</th>
                        <th>Nationality</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Occupation</th>
                      </tr>
                    </thead>
                    <tbody class="dashboard-bg-white">
                      <tr
                        *ngFor="
                          let trip of passengerSingleResponse.travel_info_inbound
                            | paginate: config;
                          index as i
                        "
                      >
                        <!-- <td>{{ trip.departure_country }}</td>
                        <td>{{ trip.departure_date | date: "medium" }}</td>
                        <td>{{ trip.return_date | date: "medium" }}</td> -->
                        <td>
                          {{
                            trip.arrival_country ? trip.arrival_country : "N/A"
                          }}
                        </td>
                        <td>
                          {{ trip.arrival_state ? trip.arrival_state : "N/A" }}
                        </td>
                        <td>
                          {{ trip.arrival_date ? trip.arrival_date : "N/A" }}
                        </td>
                        <td>
                          {{
                            trip.transit_country ? trip.transit_country : "N/A"
                          }}
                        </td>
                        <td>{{ trip.airline ? trip.airline : "N/A" }}</td>
                        <td>{{ trip.status ? trip.status : "N/A" }}</td>
                        <td>
                          {{
                            trip.country_residence
                              ? trip.country_residence
                              : "N/A"
                          }}
                        </td>
                        <td>
                          {{
                            trip.address_residential
                              ? trip.address_residential
                              : "N/A"
                          }}
                        </td>
                        <td>
                          {{ trip.nationality ? trip.nationality : "N/A" }}
                        </td>
                        <td>{{ trip.email ? trip.email : "N/A" }}</td>
                        <td>{{ trip.phone ? trip.phone : "N/A" }}</td>
                        <td>{{ trip.occupation ? trip.occupation : "N/A" }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Travel History Table - Inbound -->

        <!-- Start Travel History Table - Outbound  -->
        <div
          class="row"
          *ngIf="
            passengerSingleResponse.travel_info_outbound &&
            passengerSingleResponse.travel_info_outbound.length
          "
        >
          <hr />
          <div class="col-md-12">
            <div class="">
              <div class="mt-5">
                <div class="col-auto">
                  <div class="row">
                    <div class="col-md-12">
                      <!-- <h3>Outbound Travel Record</h3> -->
                    </div>
                  </div>
                </div>

                <div class="table">
                  <table
                    class="table-responsive"
                    datatable
                    [dtOptions]="dtOptions"
                    width="100%"
                  >
                    <thead class="">
                      <tr>
                        <th>Departing Country</th>
                        <th>Departure Date</th>
                        <th>Return Date</th>

                        <!-- <th >Arriving Country</th>
                        <th >Arriving State</th>
                        <th >Arrival Date</th> -->

                        <th>Transit Country</th>
                        <th>Airline</th>
                        <th>Test Status</th>
                        <th>Country Of Residence</th>
                        <th>Residential Address</th>
                        <th>Nationality</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Occupation</th>
                      </tr>
                    </thead>
                    <tbody class="dashboard-bg-white">
                      <tr
                        *ngFor="
                          let trip of passengerSingleResponse.travel_info_outbound
                            | paginate: config;
                          index as i
                        "
                      >
                        <td>{{ trip.departure_country ? trip.departure_country : 'N/A' }}</td>
                        <td>{{ trip.departure_date | date: "medium" }}</td>
                        <td>{{ trip.return_date | date: "medium" }}</td>
                        <!-- <td>{{ trip.arrival_country }}</td>
                        <td>{{ trip.arrival_state }}</td>
                        <td>{{ trip.arrival_date }}</td> -->
                        <td>{{ trip.transit_country ? trip.transit_country : "N/A" }}</td>
                        <td>{{ trip.airline ? trip.airline : "N/A" }}</td>
                        <td>{{ trip.status ? trip.status : "N/A" }}</td>
                        <td>{{ trip.country_residence ? trip.country_residence : "N/A" }}</td>
                        <td>{{ trip.address_residential ? trip.address_residential : "N/A" }}</td>
                        <td>{{ trip.nationality ? trip.nationality : "N/A" }}</td>
                        <td>{{ trip.email ? trip.email : "N/A" }}</td>
                        <td>{{ trip.phone ? trip.phone : "N/A" }}</td>
                        <td>{{ trip.occupation ? trip.occupation : "N/A" }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Travel History Table - Outbound -->

        <!-- Start Appointment Details Table  -->
        <!-- <div class="row">
                    <hr />
                    <div class="col-md-12">         
                      <div class="">
                        <div class="table-responsive mt-5">
                          <div class="col-auto">
                            <div class="row">
                              <div class="col-md-12">
                                <h3>Appointment Details</h3>
                              </div>
                            </div>
          
                            <div class="row">                    
                            <div class="show-record mt-3 mbm-32">
                              <span>Show</span> &nbsp;
                              <select
                                class="
                                  custom-select custom-select-sm
                                  form-control form-control-sm
                                "
                                (change)="setItemsPerPage(page.value)"
                                #page
                              >
                                <option [selected]="currentPageLength == 10">
                                  10
                                </option>
                                <option [selected]="currentPageLength == 30">
                                  30
                                </option>
                                <option [selected]="currentPageLength == 50">
                                  50
                                </option>
                                <option [selected]="currentPageLength == 100">
                                  100
                                </option>
                                <option [selected]="currentPageLength == 500">
                                  500
                                </option>
                                <option [selected]="currentPageLength == 1000">
                                  1000
                                </option>
                              </select>
                              &nbsp;
                              <span> entries</span>
                            </div>
                          </div>
                          </div>
          
                          <table
                            class="
                              table
                              table-bordered
                              table-condensed
                              table-responsive-sm
                              table-responsive-md
                              table-responsive-lg
                              table-responsive-xl
                              nowrap
                            "
                            datatable
                            [dtOptions]="dtOptions"
                            width="100%"
                          >
                            <thead class="">
                              <tr>
                                <th >S/N</th>
                                <th >Booking Date</th>
                                <th >Expected City</th>
                                <th >Expected State</th>
                                <th >Prefer State</th>
                                <th >Created At</th>
                              </tr>
                            </thead>
                            <tbody class="dashboard-bg-white">
                              <tr>
                                <th scope="row">1</th>
                                <th>25 March 2021</th>
                                <th>28 March 2021</th>
                                <th>AquaAirline</th>
                                <th>Nigeria</th>
                                <th>Ghana</th>
                              </tr>
                            </tbody>
                          </table>
          
                          <div class="table-footer">
                          <div
                            id="page_info"
                            class="mt-3 record-show-text-bottom"
                            *ngIf="registeredPassengers"
                          >
                            Showing
                            {{
                              (config.currentPage - 1) * config.itemsPerPage + 1
                            }}
                            - {{ config.currentPage * config.itemsPerPage }} of
                            {{ config.totalItems }} entries
                          </div>
          
                          <div
                            class="pagination paging-pull-right"
                            *ngIf="registeredPassengers"
                          >
                            <pagination-controls
                              (pageChange)="pageChange($event)"
                              class="my-pagination mt-2 pagination-server"
                            >
                            </pagination-controls>
                          </div>
                        </div>
                        </div>
                      </div>            
                    </div>
                  </div> -->
        <!-- End Appointment Details Table -->

        <!-- Start Covid Test Details Table  -->
        <!-- <div class="row">
                      <hr />
                      <div class="col-md-12">         
                        <div class="">
                          <div class="table-responsive mt-5">
                            <div class="col-auto">
                              <div class="row">
                                <div class="col-md-12">
                                  <h3>Covid Test Details</h3>
                                </div>
                              </div>
            
                            </div>
            
                            <table
                              class="
                                table
                                table-bordered
                                table-condensed
                                table-responsive-sm
                                table-responsive-md
                                table-responsive-lg
                                table-responsive-xl
                                nowrap
                              "
                              datatable
                              [dtOptions]="dtOptions"
                              width="100%"
                            >
                              <thead class="">
                                <tr>
                                 
                                  <th >Col 1</th>
                                  <th >Col 2</th>
                                  <th >Col 3</th>
                                </tr>
                              </thead>
                              <tbody class="dashboard-bg-white">
                                <tr>
                                  <th>Val 1</th>
                                  <th>Val 2</th>
                                  <th>Val 3</th>
                                </tr>
                              </tbody>
                            </table>
        
                          </div>
                        </div>            
                      </div>
                    </div> -->
        <!-- End Covid Test Details Table -->
      </form>
    </div>
  </div>
</ng-template>

<app-footer-dashboard></app-footer-dashboard>
